<div class="flex flex-col gap-3 h-full">
  @if (topic) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          {{ topic?.label }} ({{ topicRegisterItems.length }})
        </mat-card-title>
      </mat-card-header>
      @if (topic.desc) {
        <mat-card-content>
          {{ topic.desc }}
        </mat-card-content>
      }
    </mat-card>
  }

  <mat-card class="flex-auto overflow-auto">
    @if (cores.length > 1) {
      <div class="mb-2">
        <mat-form-field class="w-full" subscriptSizing="dynamic">
          <mat-label>{{ 'catalog.form_search.form_settings.core' | transloco }}</mat-label>
          <mat-select (valueChange)="changeCoreId.emit($event)" [value]="activeCoreId">
            @for (core of cores; track core) {
              <mat-option [value]="core.coreId">
                {{ core.coreName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <cat-topic-register-list
      (action)="search.emit([topic, $event])"
      [items]="topicRegisterItems"
      [showCount]="topic?.showCounts"
    ></cat-topic-register-list>
  </mat-card>
</div>
